import React from 'react';
import './Screen.css';

function KeyboardShortcut() {
  return (
    <span className="keyboard-shortcut">
      <kbd className="key key-shift">⇧</kbd>
      <span className="key-separator">+</span>
      <kbd className="key key-enter">↵</kbd>
    </span>
  );
}

export default KeyboardShortcut;

